import { type SemanticTokens, SEMANTIC } from '../tokens/semantic.js';

/**
 * Badge Component Configuration
 * Small indicator pills used standalone or as overlays on other components.
 */
export function createBadge(s: SemanticTokens) {
  return {
    root: {
      borderRadius: s.radius.full,
      padding: '0 0.5rem',
      fontSize: '0.75rem',
      fontWeight: '700',
      minWidth: '1.5rem',
      height: '1.5rem',
    },
    dot: {
      size: '0.5rem',
    },
    sm: {
      fontSize: '0.625rem',
      minWidth: '1.25rem',
      height: '1.25rem',
    },
    lg: {
      fontSize: '0.875rem',
      minWidth: '1.75rem',
      height: '1.75rem',
    },
    xl: {
      fontSize: '1rem',
      minWidth: '2rem',
      height: '2rem',
    },
    colorScheme: {
      light: {
        primary: {
          background: s.interactive.primary.base,
          color: s.text.onColor,
        },
        secondary: {
          background: s.interactive.secondary.base,
          color: s.text.onColor,
        },
        success: {
          background: s.interactive.success.base,
          color: s.text.onColor,
        },
        info: {
          background: s.states.info.fg,
          color: s.text.onColor,
        },
        warn: {
          background: s.interactive.warning.base,
          color: s.text.onColor,
        },
        danger: {
          background: s.interactive.danger.base,
          color: s.text.onColor,
        },
        contrast: {
          background: s.surface.dark,
          color: s.text.onColor,
        },
      },
    },
  };
}

export const badge = createBadge(SEMANTIC);
